{
	"blockedPlace": "El local {{placeName}} está bloqueado",
	"blockedPlaces": "Los locales {{placeName}} están bloqueados",
	"certificatesAboutToExpire": "¡Los certificados digitales de los perfiles fiscales {{value}} caducarán en menos de 30 días!",
	"expiredCertificates": "¡Los certificados digitales de los perfiles fiscales {{value}} han caducado!",
	"isApproved": "¡Atención! Este local está en estado de preaprobación, no será posible abrir eventos hasta que se realice la aprobación.",
	"requests_one": "¡Atención! Usted tiene {{value}} solicitud de retiro de proveedor pendiente",
	"requests_other": "¡Atención! Usted tiene {{value}} Solicitudes de retiro de proveedores pendientes"
}
